type JSONCompany = {
  brand_primary_color?: string;
  brand_secondary_color?: string;
  company_name?: string;
  email?: string;
  facebook?: string;
  instagram?: string;
  reply_to_email?: string;
  twitter?: string;
  unsupported_store?: string;
  website?: string;
};

type Company = {
  brandPrimaryColor?: string;
  brandSecondaryColor?: string;
  companyName?: string;
  email?: string;
  facebook?: string;
  instagram?: string;
  replyToEmail?: string;
  twitter?: string;
  unsupportedStore?: string;
  website?: string;
};

const toJSON = (company: Company): JSONCompany => ({
  brand_primary_color: company.brandPrimaryColor ?? '',
  brand_secondary_color: company.brandSecondaryColor ?? '',
  company_name: company.companyName ? company.companyName : '',
  email: company.email ? company.email : '',
  facebook: company.facebook ? extractHandler(company.facebook) : '',
  instagram: company.instagram ? extractHandler(company.instagram) : '',
  reply_to_email: company.replyToEmail ?? '',
  twitter: company.twitter ? extractHandler(company.twitter) : '',
  website: company.website ? company.website : '',
});

const fromJSON = (data: JSONCompany): Company => ({
  brandPrimaryColor: data.brand_primary_color,
  brandSecondaryColor: data.brand_secondary_color,
  companyName: data.company_name,
  email: data.email,
  facebook: data.facebook,
  instagram: data.instagram,
  replyToEmail: data.reply_to_email,
  twitter: data.twitter,
  unsupportedStore: data.unsupported_store,
  website: data.website,
});

const extractHandler = (url: string) => {
  const splitted = url.split('/');
  return splitted.pop() || splitted.pop(); // deals with trailing slash;
};

export default Company;

export { Company, JSONCompany, fromJSON, toJSON };
